/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { useState, useRef, useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { PageFooterWrapper } from '@usb-ui-tools/react-billpay-layout'
import VerifybillsHeader from '../../../../modules/payees/findbills/verifybills/header/verifybills-header'
import VerifyBillsContainer from '../../../../modules/payees/findbills/verifybills/verifybills/verifybills'
import {
  isOLBOrIpadApp,
  isTuxApp,
  navigateRoute
} from '../../../../utils/browserutils'
import useForm from './useForm'
import { useVerifyPotentialService } from '../../../../service/payees/verify_potential.service'
import { getbillerCache } from '../../../../graphql/cache/localCache'
import Loader from '../../../../components/spinner'
import {
  getverifiedBillsPayload,
  redirectToDashboard,
  sortedList
} from '../../../../utils/verifyBills'
import { PageviewTealiumEvent } from '../../../../utils/tealiumwrapper'
import { PAGE_NAMES } from '../../../../constants/tealiumData'
import handleVerifyBillError from '../../../../utils/handleVerifyBillError'
import ErrorComponent from '../../error'
import { useMultilingualService } from '../../../../service/multilingualService'
import MobileBillPayLayout from '../../../../modules/layout/MobileBillPayLayout'
import { errorContentCache } from '../../../../context/appCache'
import {
  getSessionStorageValue,
  setSessionStorageValue
} from '../../../../utils/sessionUtils'
import { updateOnboardingFeatureNew } from '../../../../utils/poaUtils'
import { OnboardingSuccessInfoLogger } from '../../../../utils/loggerUtils'

const VerifyBills = () => {
  const langError = useMultilingualService('error')
  const [pageErrorMsg, setPageErrorMsg] = useState('')
  const [inlineMsg, setInlineMsg] = useState('')
  const [isSystemError, setSystemError] = useState(false)
  const [isFieldsValidationError, setFieldsValidationError] = useState(false)
  const [apierror, setApiError] = useState(false)
  const [errorCount, setErrorCount] = useState(0)
  const [submitStatus, setSubmitStatus] = useState(false)
  const [potentialError, setPotentialError] = useState([])
  const stateSchema = {}
  const [count, setCount] = useState(0)
  const stateValidatorSchema = {}
  const footerRef = useRef()
  const errorNotificaitonText = ''
  const [hidePage, setHidepage] = useState(false)
  const {
    loadApi,
    loading,
    // error: potentialError,
    data: potentialData
  } = useVerifyPotentialService()

  const { verifiedBills, nonVerifiedBills } = useReactiveVar(getbillerCache)
  const { FOOTER, VERIFY_BILLS } = useMultilingualService('findbills')

  const [getVerify, setVerify] = useState(nonVerifiedBills)

  const verifyLength = getVerify && getVerify.length

  const billerName = []
  if (getVerify && getVerify.length > 0) {
    getVerify.map((data) => {
      billerName.push(data?.merchantData?.billerName)
      errorContentCache({ billerName })
      data.verificationTokens.map((data1) => {
        const name = `${data.payeeId}_${data1.tokenDescription}_${data1.tokenType}`

        stateSchema[name] = { value: '', error: '' }
        stateValidatorSchema[name] = {
          required: true,
          propName: name,
          validator: {
            func: (value) => /^[a-zA-Z0-9_@!+#.$,%^ *-]{1,32}$/.test(value), //eslint-disable-line
            error: `Please enter a valid ${data1.tokenDescription}`
          }
        }

        return true
      })
      return true
    })
  }
  const { values, errors, dirty, handleOnChange, handleResetForm } = useForm(
    (statedata) => statedata,
    'Please enter your ',
    stateSchema,
    stateValidatorSchema
  )
  const fromOnboarding = JSON.parse(getSessionStorageValue('fromOnboarding'))

  const handleFooterClick = (event, type) => {
    if (event && type === 'yes') {
      setSubmitStatus(true)
      setErrorCount(errorCount + 1)
      let isEmptyField = false
      if (typeof values === 'object' && values) {
        const payload = {}
        const verifyPayeesParameters = []

        Object.keys(values).forEach((data) => {
          const [payeeId, tokenName, tokenType] = data && data.split('_')
          getVerify.forEach((item) => {
            if (item.payeeId === payeeId) {
              if (payload[payeeId] === undefined) payload[payeeId] = {}
              payload[payeeId][tokenName] = {
                tokenDescription: tokenName,
                tokenType
              }

              if (values[data]) {
                payload[payeeId][tokenName].tokenValue = values[data]
              } else {
                isEmptyField = true
              }
            }
          })
        })
        Object.keys(payload).forEach((payeeID) => {
          const verificationTokens = Object.keys(payload[payeeID]).map(
            (token) => ({ ...payload[payeeID][token] })
          )

          if (verificationTokens.length > 0) {
            verifyPayeesParameters.push({ payeeID, verificationTokens })
          }
        })

        if (!isEmptyField) {
          setCount(count + 1)
          setErrorCount(0)
          const verifiedPayeesParameters =
            getverifiedBillsPayload(verifiedBills)
          loadApi({
            variables: {
              appName: 'BILLPAY',
              verifyPotentialPayeeRequest: {
                verifyPayeesParameters: [
                  ...verifyPayeesParameters,
                  ...verifiedPayeesParameters
                ]
              }
            }
          })
          handleResetForm(stateValidatorSchema)
        } else {
          getVerify.map((data) => {
            data.verificationTokens.map((data1) => {
              const name = `${data.payeeId}_${data1.tokenDescription}_${data1.tokenType}`
              if ((dirty[name] || submitStatus) && !values[name]) {
                setErrorCount(errorCount + 1)
              }
              return errorCount
            })
            return errorCount
          })
        }
      }
    } else if (event && type === 'no') {
      const verifiedPayeesParameters = getverifiedBillsPayload(verifiedBills)
      if (verifiedPayeesParameters && verifiedPayeesParameters?.length > 0) {
        loadApi({
          variables: {
            appName: 'BILLPAY',
            verifyPotentialPayeeRequest: {
              verifyPayeesParameters: [...verifiedPayeesParameters]
            }
          }
        })
      } else {
        redirectToDashboard()
      }
    }
  }
  const handleSuccess = () => {
    OnboardingSuccessInfoLogger('DIY_BILLPAY', 'FIND_BILL_SUCCESS')
  }
  const handleFailure = () => {
    OnboardingSuccessInfoLogger('DIY_BILLPAY', 'FIND_BILL_FAILED')
  }
  useEffect(() => {
    const callPoaAndNavigateToDashboard = async () => {
      if (
        potentialData &&
        potentialData?.verifyPotentialPayee &&
        potentialData?.verifyPotentialPayee?.verifiedPayees?.length > 0
      ) {
        const potentialPayeeListData =
          potentialData?.verifyPotentialPayee?.verifiedPayees
        const potentialErrorList = potentialPayeeListData?.filter(
          (item) => item?.errorCode
        )
        setPotentialError(potentialErrorList)
        // update POA here for onboarding, verify payee success
        if (fromOnboarding) {
          await updateOnboardingFeatureNew(handleSuccess, handleFailure)
          setSessionStorageValue('isBillpaySuccess', 'true')
        }
        if (potentialErrorList?.length === 0) {
          redirectToDashboard(
            potentialData?.verifyPotentialPayee?.verifiedPayees?.length
          )
        }
      } else {
        setHidepage(false)
      }
    }
    setHidepage(true)
    callPoaAndNavigateToDashboard()
  }, [potentialData])
  useEffect(() => {
    if (potentialError && potentialError?.length > 0) {
      setHidepage(false)
      handleVerifyBillError(
        potentialError,
        setSystemError,
        setFieldsValidationError,
        setPageErrorMsg,
        setInlineMsg,
        setApiError,
        billerName
      )
    }
  }, [potentialError])

  useEffect(() => {
    PageviewTealiumEvent(PAGE_NAMES.VERIFY_BILL_DAHSBOARD)
  }, [])

  const removeverified = (rmpayeeId) => {
    const billerToBeRemoved = nonVerifiedBills.findIndex(
      (obj) => obj.payeeId === rmpayeeId
    )
    nonVerifiedBills.splice(billerToBeRemoved, 1)
    setVerify([...sortedList(nonVerifiedBills)])
  }
  const getBillTextCTA = () => {
    if (nonVerifiedBills && nonVerifiedBills?.length > 0) {
      const billText =
        nonVerifiedBills?.length === 1 ? FOOTER?.BILL : FOOTER?.BILLS
      return `${FOOTER?.ADD} ${nonVerifiedBills?.length} ${billText}`
    }
    const billTextver =
      verifiedBills?.length === 1 ? FOOTER?.BILL : FOOTER?.BILLS
    return `${FOOTER?.ADD} ${verifiedBills?.length} ${billTextver}`
  }
  if (loading || hidePage) {
    return <Loader />
  }
  return (
    <>
      {!loading && !isSystemError && !hidePage && (
        <PageFooterWrapper
          isOLBOrIpadApp={isOLBOrIpadApp}
          id="verify-bill-footer"
          forwardedRef={footerRef}
          buttonOptions={[
            {
              type: 'primary ',
              text: getBillTextCTA(),
              clickEvent: (e) => {
                handleFooterClick(e, 'yes')
              },
              show: true,
              id: 'verify-bill-skip-button'
            },
            {
              type: 'text',
              text: VERIFY_BILLS?.FOOTER?.SKIP_QUESTIONS,
              clickEvent: (e) => {
                handleFooterClick(e, 'no')
              },
              show: true,
              id: 'verify-bill-add-button'
            }
          ]}
        >
          {isTuxApp() && <MobileBillPayLayout />}
          {/* {!loading && !isSystemError && ( */}
          <>
            <VerifybillsHeader
              {...{
                isFieldsValidationError,
                pageErrorMsg,
                submitStatus,
                verifyLength,
                count,
                errorNotificaitonText
              }}
            />
            <VerifyBillsContainer
              verifiedBills={sortedList(verifiedBills)}
              nonVerifiedBills={sortedList(nonVerifiedBills)}
              handleOnChange={handleOnChange}
              errors={errors}
              handleBillerRemoval={removeverified}
              errorCount={errorCount}
              count={count}
              inlineMsg={inlineMsg}
              apierror={apierror}
            />
          </>
        </PageFooterWrapper>
      )}
      {isSystemError && <ErrorComponent />}
    </>
  )
}
export default VerifyBills
